'use strict'

module.exports = {
  USER: 1,
  CALL: 2,
  COMPONENT: 3,
};
